import { Component, OnInit } from '@angular/core';
import { HeaderComponent } from '@shared/components/header/header.component';
import { TranslatePipe } from '@ngx-translate/core';
import { ActivatedRoute, ParamMap, RouterOutlet } from '@angular/router';
import { AlertService } from '@app/core/services/alert.service';

import { NavItem } from '@shared/interfaces/nav/nav-item';
import { generateNavItems } from '@app/core/utils/generate-nav-items';
import { veeNavItems } from '@views/vee/vee-details/vee.nav-items';
import { EstimationGroupDto } from '@app/api/dmc';

@Component({
  selector: 'app-vee-details',
  imports: [
    HeaderComponent,
    TranslatePipe,
    RouterOutlet,
  ],
  templateUrl: './vee-details.component.html',
  styleUrl: './vee-details.component.css'
})
export class VeeDetailsComponent implements OnInit {
  /** ID **/
  public id!: string;

  /** Navigation **/
  public navItems: NavItem[] = [];

  /** VEE **/
  public vee?: EstimationGroupDto;

  constructor(
    private readonly alertService: AlertService,
    private readonly route: ActivatedRoute,
  ) {
    this.alertService.open('header', 'info', 'vee.details.info');

    this.route.paramMap.subscribe((q: ParamMap) => {
      this.id = q.get('id')!;
    });
  }

  public ngOnInit(): void {
    this.navItems = generateNavItems(veeNavItems, 'id', this.id)
  }



}
